import { create } from "zustand";
import { api } from "../utils/axios-instance";
import { auth } from "../helper/firebaseClient";

export const useEventStore = create((set, get) => ({
  localEvents: [],
  loading: false,

  fetchLocalEvents: async () => {
    set({ loading: true });
    try {
      const token = auth.currentUser && (await auth.currentUser.getIdToken());
      if (!token) return;

      const response = await api.get(`/users/events/list/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const parsedEvents = response.data.map(e => ({
        id: e.id,
        title: e.title,
        date: new Date(e.start_date),
        end_date: new Date(e.end_date),
        category: e.category,
        isGoogle: false,
        department_name: e.department_name
      }));

      set({ localEvents: parsedEvents });
    } catch (err) {
      console.error("Failed to fetch local events", err);
    } finally {
      set({ loading: false });
    }
  },

  createLocalEvent: async (eventData) => {
    try {
      const token = auth.currentUser && (await auth.currentUser.getIdToken());
      if (!token) return;

      const response = await api.post(`/users/events/create/`, eventData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const newEvent = {
        id: response.data.id,
        title: response.data.title,
        date: new Date(response.data.start_date),
        end_date: new Date(response.data.end_date),
        category: response.data.category,
        isGoogle: false,
        department_name: response.data.department_name
      };

      set((state) => ({ localEvents: [...state.localEvents, newEvent] }));
      return true;
    } catch (err) {
      console.error("Failed to create event", err);
      return false;
    }
  },

  updateLocalEvent: async (eventId, eventData) => {
    try {
      const token = auth.currentUser && (await auth.currentUser.getIdToken());
      if (!token) return;

      const response = await api.put(`/users/events/update/${eventId}/`, eventData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const updatedEvent = {
        id: response.data.id || eventId,
        title: response.data.title,
        date: new Date(response.data.start_date),
        end_date: new Date(response.data.end_date),
        category: response.data.category,
        isGoogle: false,
        department_name: response.data.department_name
      };

      set((state) => ({
        localEvents: state.localEvents.map(e => e.id === eventId ? updatedEvent : e)
      }));
      return true;
    } catch (err) {
      console.error("Failed to update event", err);
      return false;
    }
  },

  deleteLocalEvent: async (eventId) => {
    try {
      const token = auth.currentUser && (await auth.currentUser.getIdToken());
      if (!token) return;

      await api.delete(`/users/events/delete/${eventId}/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      set((state) => ({ localEvents: state.localEvents.filter(e => e.id !== eventId) }));
      return true;
    } catch (err) {
      console.error("Failed to delete event", err);
      return false;
    }
  }
}));
